import api from "./api";

export default class API {
  uploadCaptureMarkupImage(callUUID, filedata) {
    return api.postMultipartFormData(`call/${callUUID}/picture`, filedata);
  }
}
